import { defineComponent as _defineComponent } from 'vue';
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "barArrowButtonSlotContent" };
const _hoisted_2 = ["src"];
import { ref, computed, onMounted } from 'vue';
import BarArrowButton from './BarArrowButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PlanInfoPanel',
    props: {
        title: {},
        href: {},
        plan: {},
        spent: {},
        formatter: {},
        hideArrow: { type: Boolean },
        iconPath: {},
        bgColour: {},
        alt: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const animatedProgress = ref(0);
        const planProgressPercent = computed(() => {
            return Math.min(100, Math.max(0, Math.round(((props.spent ?? 0) / (props.plan ?? 1)) * 100)));
        });
        const planLabel = computed(() => {
            if (!props.plan || props.plan <= 0)
                return "Set up your first spending plan today!";
            const difference = props.plan - (props.spent ?? 0);
            let label = " left";
            if (difference < 0)
                label = " over";
            const text = "Plan: " + props.formatter.format(props.plan) + " | " + props.formatter.format(Math.round(Math.abs(difference))) + label;
            return text;
        });
        function animateProgress(targetValue) {
            animatedProgress.value = 0;
            const increment = targetValue / 50;
            const interval = setInterval(() => {
                if (animatedProgress.value < targetValue) {
                    animatedProgress.value += increment;
                }
                else {
                    animatedProgress.value = targetValue;
                    clearInterval(interval);
                }
            }, 10);
        }
        onMounted(() => {
            animateProgress(planProgressPercent.value);
        });
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_progress_linear = _resolveComponent("v-progress-linear");
            return (_openBlock(), _createBlock(BarArrowButton, {
                large: true,
                title: _ctx.title,
                href: _ctx.href,
                hideArrow: _ctx.hideArrow,
                style: _normalizeStyle(_ctx.alt ? 'background-color: var(--background-color-alt)' : '')
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                                (_ctx.iconPath)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 0,
                                        cols: "2",
                                        class: "iconCol"
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("img", {
                                                src: require('@/assets/transactions/' + _ctx.iconPath.toLowerCase().replace('.svg', '.png')),
                                                class: "icon",
                                                style: _normalizeStyle({ background: _ctx.bgColour })
                                            }, null, 12, _hoisted_2)
                                        ]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true),
                                _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => [
                                        _createElementVNode("span", null, _toDisplayString(planLabel.value), 1)
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }),
                        (_ctx.plan && _ctx.plan > 0)
                            ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_col, { class: "progressCol" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_progress_linear, {
                                                class: _normalizeClass(_ctx.plan > _ctx.spent ? 'progress' : 'progressExceeded'),
                                                height: "7",
                                                "model-value": animatedProgress.value,
                                                color: "primary",
                                                rounded: ""
                                            }, null, 8, ["class", "model-value"])
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _: 1
            }, 8, ["title", "href", "hideArrow", "style"]));
        };
    }
});
